export default __webpack_public_path__ + "static/media/google-calendar.769c42d3.svg";